import React, {useState, useEffect} from 'react'
import logo from '../images/logo.png'
import { Link } from 'react-router-dom';


const Header = () =>{

    const [isOpen, setIsOpen] = useState(false);
     const [isScrolled, setIsScrolled] = useState(false);

     
       // Detect scroll position
       useEffect(() => {
         const handleScroll = () => {
           setIsScrolled(window.scrollY > 50); // If scrolled more than 50px, add background
         };
         
         window.addEventListener("scroll", handleScroll);
         return () => window.removeEventListener("scroll", handleScroll);
       }, []);


    return (
        <header>
        <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${isScrolled ? "bg-secondary-100 shadow-lg" : "bg-transparent"}`}>
          <div className="container mx-auto flex justify-between items-center p-4">
            {/* Logo */}
            <a href="#" className="text-2xl font-bold text-primary font-psemibold"><img src={logo} className="w-[150px]"/></a>
    
            {/* Desktop Menu */}
            <ul className="hidden md:flex space-x-20 text-white font-pmedium mr-20">
            <li><Link to="/" className="hover:text-primary">Home</Link></li>
            <li><Link to="/register"className="hover:text-primary">Login</Link></li>
            <li><Link to="/dashboard"className="hover:text-primary">Dashboard</Link></li>
              <li><Link to="/#about" className="hover:text-primary">About Us</Link></li>
              <li><Link to="/#plan" className="hover:text-primary">Plan</Link></li>
              
              <li><Link to="/contract"className="hover:text-primary text-sm">Contract</Link></li>
            </ul>
    
            {/* Mobile Menu Button */}
            <button className="md:hidden text-white" onClick={() => setIsOpen(!isOpen)}>
              {isOpen ? <i className="fa fa-times"></i>: <i className="fa fa-bars"></i>}
            </button>
          </div>
    
          {/* Mobile Menu */}
          <div className={`md:hidden ${isOpen ? "block" : "hidden"} shadow bg-secondary-100`}>
            <ul className="flex flex-col items-center space-y-2 pb-10 font-pmedium text-white">
            <li><Link to="/" className="hover:text-primary">Home</Link></li>
            <li><Link to="/register"className="hover:text-primary">Login</Link></li>
            <li><Link to="/dashboard"className="hover:text-primary">Dashboard</Link></li>
              <li><Link to="/#about" className="hover:text-primary">About Us</Link></li>
              <li><Link to="/#plan" className="hover:text-primary">Plan</Link></li>
              
              <li><Link to="/contract"className="hover:text-primary text-sm">Contract</Link></li>
            </ul>
          </div>
        </nav>
        
        </header>
    )
}

export default Header;